import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { activitiesActions } from '@src/store/reducers/activitiesReducer';

export const createActivitiesMiddleware = (http: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [activitiesActions.GET_ACTIVITIES]: async ({ payload }: any, next: Next) => {
            const postData = {
                period: payload.period,
                projectId: payload.projectId,
                environmentId: payload.environmentId,
                activityTypeId: payload.activityTypeId,
                paging: { page: payload.pageId, count: payload.quantity }
            };
            const response = await http.post(`${restServiceUrl}Projects/Activities`, postData);
            const activities = response.data;
            next({ type: activitiesActions.SET_ACTIVITIES, payload: { activitiesData: activities, action: activitiesActions.SET_ACTIVITIES } });
            return activities;
        },
        [activitiesActions.GET_ACTIVITIES_BY_TYPE]: async ({ payload }: any, next: Next) => {
            const postData = {
                period: payload.period,
                projectId: payload.projectId,
                environmentId: payload.environmentId,
                activityTypeId: payload.activityTypeId,
                paging: { page: payload.pageId, count: payload.quantity }
            };
            const response = await http.post(`${restServiceUrl}Projects/Activities`, postData);
            const activities = response.data;
            next({ type: activitiesActions.SET_ACTIVITIES_BY_TYPE, payload: { activitiesData: activities, action: activitiesActions.SET_ACTIVITIES_BY_TYPE } });
            return activities;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/activities.middleware.ts